import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import {
    ExpertServiceDocument,
    ExpertServiceQuery,
    ExpertServiceQueryVariables,
} from '../../../graph/ExpertService.generated';

const OTHER_DESIGN_SERVICE_MPV_ID = 'otherDesign';

export type ResolveServiceProductMpvIdParams = {
    printProductMpvId: string | undefined;
};

export function useResolveServiceProductMpvId() {
    const client = useApolloClient();

    return useCallback(
        async function resolveServiceProductMpvId({
            printProductMpvId,
        }: ResolveServiceProductMpvIdParams): Promise<string> {
            if (!printProductMpvId) {
                return OTHER_DESIGN_SERVICE_MPV_ID;
            }

            try {
                const { data, error } = await client.query<
                    ExpertServiceQuery,
                    ExpertServiceQueryVariables
                >({
                    query: ExpertServiceDocument,
                    variables: { mpvId: printProductMpvId },
                });
                if (error) {
                    Bugsnag.notify(
                        new Error(
                            `Error fetching expert service for print product mpvId ${printProductMpvId}: ${error.message}`
                        )
                    );
                }
                const resolvedMpvId = data?.expertService?.serviceProduct?.mpvId;
                if (resolvedMpvId) {
                    return resolvedMpvId;
                }
            } catch (err) {
                Bugsnag.notify(
                    new Error(
                        `Error fetching expert service for print product mpvId ${printProductMpvId}: ${
                            (err as Error).message
                        }`
                    )
                );
            }

            return OTHER_DESIGN_SERVICE_MPV_ID;
        },
        [client]
    );
}
